<template>
  <div class="quiz-result-chart">
    <div
      class="quiz-result-chart__item"
      v-for="(quiz, index) in quizzes"
      :key="quiz.id"
      :class="getChartClassNames(quiz)"
    >
      {{ (index + 1) }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'quiz-result-chart',

  props: {
    pages: {
      type: Array,
      default() {
        return [];
      },
    },
    cardId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    ...mapGetters([
      'isClassStudent',
    ]),

    quizzes() {
      return this.pages.filter(page => (page.is_quiz));
    },
  },

  methods: {
    getChartClassNames(quiz) {
      if (!this.isClassStudent) {
        return {};
      }

      if (isEmpty(quiz.submitted_answers) && isEmpty(quiz.submitted_answer)) {
        return {};
      }

      let submittedAnswer;

      if (!isEmpty(quiz.submitted_answers)) {
        submittedAnswer = quiz.submitted_answers[0];
      } else if (!isEmpty(quiz.submitted_answer)) {
        submittedAnswer = quiz.submitted_answer;
      }

      return {
        'quiz-result-chart__item-is-correct': submittedAnswer.is_graded && submittedAnswer.is_correct,
        'quiz-result-chart__item-is-incorrect': submittedAnswer.is_graded && !submittedAnswer.is_correct,
        'quiz-result-chart__item-is-good-graded': (
          submittedAnswer.is_graded
            && submittedAnswer.is_correct
            && quiz.page_type.name === 'essay_type'
            && submittedAnswer.score < quiz.score
        ),
        'quiz-result-chart__item-is-not-graded': !submittedAnswer.is_graded,
      };
    },
  },
};
</script>

<style lang="scss">
  .quiz-result-chart {
    display: inline-block;

    &:before,
    &:after {
      display: table;
      content: " ";
      clear: both;
    }

    .quiz-result-chart__item {
      float: left;
      position: relative;
      width: 20px;
      height: 20px;
      background-color: #e9e9e9;
      border-radius: 4px;
      margin-right: 8px;
      margin-bottom: 8px;
      color: #ffffff;
      text-align: center;
      line-height: 1.8;
      font-size: 12px;

      &.quiz-result-chart__item-is-correct {
        background-color: #00c896;
      }

      &.quiz-result-chart__item-is-incorrect {
        background-color: #f97e76;
      }

      &.quiz-result-chart__item-is-good-graded {
        background-color: #ffc107;
      }

      &.quiz-result-chart__item-is-not-graded {
        background-color: rgba(0, 0, 0, 0.54);
      }

      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: block;
        border-radius: 4px;
        transition: background-color 0.5s ease;
      }

      &:hover {
        &:after {
          background-color: rgba(0,0,0,0.2);
        }
      }

      &:active {
        &:after {
          background-color: rgba(0,0,0,0.4);
        }
      }
    }
  }
</style>
